/* GENERADO AUTOMÁTICAMENTE por packages/tokens/scripts/generate.ts — NO EDITAR A MANO */
import type { TokensJson } from '../scripts/generate.js';

export const TOKENS = {
  "$schema": "./tokens.schema.json",
  "meta": {
    "name": "THE PIT · LOS SANTOS",
    "version": "1.0.0",
    "description": "Tokens de diseño. Fuente única (S3): de aquí se generan las CSS vars y el preset de Tailwind."
  },
  "color": {
    "bg": {
      "base": {
        "dark": "#06060a",
        "light": "#f4f5f7"
      },
      "raised": {
        "dark": "#0d0d14",
        "light": "#ffffff"
      },
      "overlay": {
        "dark": "#14141d",
        "light": "#e9ebef"
      },
      "sunken": {
        "dark": "#020204",
        "light": "#e2e5ea"
      }
    },
    "border": {
      "subtle": {
        "dark": "#1e1e2b",
        "light": "#d5d9e0"
      },
      "strong": {
        "dark": "#33334a",
        "light": "#b3b9c4"
      },
      "focus": {
        "dark": "#38e8ff",
        "light": "#0b7f96"
      }
    },
    "text": {
      "primary": {
        "dark": "#f2f3f7",
        "light": "#0d0f14"
      },
      "secondary": {
        "dark": "#a9adbd",
        "light": "#454a57"
      },
      "muted": {
        "dark": "#6b7080",
        "light": "#71767f"
      },
      "inverse": {
        "dark": "#06060a",
        "light": "#ffffff"
      }
    },
    "accent": {
      "red": {
        "dark": "#ff2e4c",
        "light": "#d3102c"
      },
      "cyan": {
        "dark": "#38e8ff",
        "light": "#0b7f96"
      },
      "amber": {
        "dark": "#ffb020",
        "light": "#a86a00"
      },
      "green": {
        "dark": "#37e07a",
        "light": "#0f8a45"
      },
      "violet": {
        "dark": "#a06bff",
        "light": "#6a34d6"
      }
    },
    "state": {
      "success": {
        "dark": "#37e07a",
        "light": "#0f8a45"
      },
      "warning": {
        "dark": "#ffb020",
        "light": "#a86a00"
      },
      "danger": {
        "dark": "#ff2e4c",
        "light": "#d3102c"
      },
      "info": {
        "dark": "#38e8ff",
        "light": "#0b7f96"
      }
    },
    "corner": {
      "red": {
        "dark": "#ff2e4c",
        "light": "#d3102c"
      },
      "blue": {
        "dark": "#38a6ff",
        "light": "#0f5fd0"
      }
    }
  },
  "typography": {
    "fontFamily": {
      "mono": [
        "'JetBrains Mono'",
        "'IBM Plex Mono'",
        "ui-monospace",
        "SFMono-Regular",
        "Menlo",
        "monospace"
      ],
      "sans": [
        "'Inter'",
        "system-ui",
        "-apple-system",
        "Segoe UI",
        "Roboto",
        "sans-serif"
      ]
    },
    "fontSize": {
      "2xs": "0.625rem",
      "xs": "0.6875rem",
      "sm": "0.8125rem",
      "base": "0.9375rem",
      "lg": "1.125rem",
      "xl": "1.375rem",
      "2xl": "1.75rem",
      "3xl": "2.25rem",
      "4xl": "3rem",
      "5xl": "4rem",
      "6xl": "5.5rem"
    },
    "fontWeight": {
      "normal": "400",
      "medium": "500",
      "semibold": "600",
      "bold": "700",
      "black": "800"
    },
    "lineHeight": {
      "tight": "1.1",
      "snug": "1.25",
      "normal": "1.5",
      "relaxed": "1.7"
    },
    "letterSpacing": {
      "tighter": "-0.03em",
      "tight": "-0.015em",
      "normal": "0",
      "wide": "0.02em",
      "wider": "0.06em",
      "widest": "0.16em"
    }
  },
  "space": {
    "0": "0",
    "1": "0.25rem",
    "2": "0.5rem",
    "3": "0.75rem",
    "4": "1rem",
    "5": "1.25rem",
    "6": "1.5rem",
    "8": "2rem",
    "10": "2.5rem",
    "12": "3rem",
    "16": "4rem",
    "20": "5rem",
    "24": "6rem"
  },
  "radius": {
    "none": "0",
    "sm": "0.25rem",
    "md": "0.5rem",
    "lg": "0.75rem",
    "xl": "1rem",
    "full": "9999px"
  },
  "shadow": {
    "sm": "0 1px 2px rgba(0,0,0,0.4)",
    "md": "0 4px 12px rgba(0,0,0,0.45)",
    "lg": "0 12px 32px rgba(0,0,0,0.5)",
    "glowRed": "0 0 0 1px rgba(255,46,76,0.35), 0 0 24px rgba(255,46,76,0.25)",
    "glowCyan": "0 0 0 1px rgba(56,232,255,0.35), 0 0 24px rgba(56,232,255,0.25)",
    "glowAmber": "0 0 0 1px rgba(255,176,32,0.35), 0 0 24px rgba(255,176,32,0.22)"
  },
  "motion": {
    "duration": {
      "instant": "0ms",
      "fast": "120ms",
      "base": "200ms",
      "slow": "320ms",
      "slower": "520ms"
    },
    "easing": {
      "standard": "cubic-bezier(0.2, 0, 0, 1)",
      "decelerate": "cubic-bezier(0, 0, 0, 1)",
      "accelerate": "cubic-bezier(0.3, 0, 1, 1)",
      "spring": "cubic-bezier(0.34, 1.56, 0.64, 1)"
    }
  },
  "zIndex": {
    "base": "0",
    "raised": "10",
    "sticky": "100",
    "overlay": "500",
    "modal": "1000",
    "toast": "2000",
    "hud": "3000"
  },
  "breakpoint": {
    "sm": "480px",
    "md": "768px",
    "lg": "1024px",
    "xl": "1280px",
    "2xl": "1536px"
  },
  "size": {
    "touchTargetMin": "44px",
    "headerHeight": "56px",
    "tabbarHeight": "60px",
    "hudTicketRow": "34px"
  }
} as const satisfies TokensJson;

export const THEME_ATTRIBUTE = 'data-theme' as const;
export type ThemeName = 'dark' | 'light';
export const DEFAULT_THEME: ThemeName = 'dark';

/** Nombre de variable CSS de un color temático. */
export function colorVar(group: string, key: string): string {
  return `var(--pit-${group}-${key})`;
}
